import { imageIdFormat } from "@redotech/redo-model/ids";
import { ImageOptimizationStatusSchema } from "@redotech/redo-model/inventory/image-generation";
import * as z from "zod/v4";

const GeneratedImageSchema = z.object({
  id: imageIdFormat.schema,
  url: z.string(),
});

export const getImageOptimizationStatus = {
  name: "getImageOptimizationStatus" as const,
  input: z.object({
    workflowId: z.string(),
  }),
  output: z.object({
    status: ImageOptimizationStatusSchema,
    currentStep: z.number(),
    totalSteps: z.number(),
    imagesProcessed: z.number(),
    totalImages: z.number(),
    elapsedTimeMs: z.number(),
    estimatedRemainingTimeMs: z.number().optional(),
    error: z.string().optional(),
    images: z.array(GeneratedImageSchema).optional(),
  }),
};
